// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

// Validation
import { Validator } from 'react-vld'
import { validateEqualStrings } from 'utils/validation'

// Actions
import { managerEmailVerify } from 'actions/actions'

// Atoms
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import { LinkButton } from 'atoms/Link'
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import FormCard from 'atoms/FormCard'
import CenteredCard from 'atoms/CenteredCard'

const mapDispatchToProps = {
  managerEmailVerifyAction: managerEmailVerify
}

export default
@connect(null, mapDispatchToProps)
@withRouter
class ManagerEmailVerifyAction extends Component {
  static propTypes = {
    managerEmailVerifyAction: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    token: PropTypes.string,
  }

  state = {
    password: '',
    confirmPassword: '', // eslint-disable-line
  }

  validateConfirmPassword = () => {
    const { value: password } = this.passwordInput.state
    const { value: confirmPassword } = this.confirmPasswordInput.state
    validateEqualStrings(password, confirmPassword, 'Passwords do not match')
  }

  handleSubmit = async (cancelToken) => {
    const { managerEmailVerifyAction, token, history } = this.props
    const { password } = this.state
    await managerEmailVerifyAction(token, password, cancelToken)
    history.replace({
      pathname: '/inbox',
      state: { emailJustVerified: true }
    })
  }

  handleFieldSave = fieldName => (value) => {
    this.setState({ [fieldName]: value })
  }

  passwordInputRef = (input) => {
    this.passwordInput = input
  }

  confirmPasswordInputRef = (input) => {
    this.confirmPasswordInput = input
  }

  renderField(fieldName, props) {
    const { [fieldName]: value } = this.state
    return (
      <TextInput
        required
        minLength={6}
        withBorder
        type="password"
        placeholder="******"
        defaultValue={value}
        onSave={this.handleFieldSave(fieldName)}
        {...props}
      />
    )
  }

  render() {
    return (
      <FormCard
        component={CenteredCard}
        onSubmit={this.handleSubmit}
        title="Set your password"
        applyButton={<Button>Set password</Button>}
        cancelButton={<LinkButton to="/">Cancel</LinkButton>}
      >
        <CardContent>
          { this.renderField('password', {
            label: 'Password',
            innerRef: this.passwordInputRef,
          }) }
          <Spacer />
          <Validator rule={this.validateConfirmPassword}>
            { passwordValidation => this.renderField('confirmPassword', {
              validation: passwordValidation,
              label: 'Confirm password',
              innerRef: this.confirmPasswordInputRef,
            }) }
          </Validator>
        </CardContent>
      </FormCard>
    )
  }
}
